export default "__VITE_PUBLIC_ASSET__57adc2e5__"